import React from 'react'
import AboutImage from '../../images/about/about_image.jpg'

const About = (props) => {
    return (

        <section className="tf-about-section section-padding">
            <div className="container">
                <div className="tf-about-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="tf-about-img">
                                <img src={AboutImage} alt="" />

                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="tf-about-text">
                                <small>about Me</small>
                                <h2>Hey there, I'm Iván</h2>
                                <h5>
                                    Game Programmer with {new Date().getFullYear() - 2020}+ years of professional experience in C++/Unreal Engine and C#/Unity
                                </h5>
                                <p>
                                    Passionate about systems architecture, scalable game systems, and performance optimization. Good expertise in tools development, UI systems, and gameplay frameworks. Excellent communication and teamwork skills, with experience mentoring junior developers and defining best practices with leads and colleagues.
                                </p>

                                <div className="tf-funfact">
                                    <div className="tf-funfact-item">
                                    <h3>
                                        <a
                                        href="https://www.linkedin.com/in/ivan-auteville/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >
                                        <i className="ti-linkedin"></i>
                                        </a>
                                    </h3>
                                    <p>LinkedIn</p>
                                    </div>

                                    <div className="tf-funfact-item">
                                    <h3>
                                        <a
                                        href="mailto:ivangarciaauteville@gmail.com?"
                                        >
                                        <i className="ti-email"></i>
                                        </a>
                                    </h3>
                                    <p>Email</p>
                                    </div>

                                    <div className="tf-funfact-item">
                                    <h3>
                                        <a
                                        href="https://drive.google.com/uc?export=download&id=1hH-qS2cMrzf5KKaLGqbfqDmAS7BLtDcp"download
                                        >
                                        <i className="ti-download"></i>
                                        </a>
                                    </h3>
                                    <p>My CV</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;